// @ts-check

/**
 * @file Provides the shared React Native Text wrapper.
 */

import {memo} from "react"
import {Text as RNText} from "react-native"
import {useMergedStyle} from "@kaspernj/api-maker/build/utils/default-style"

/** @import {ReactElement, ReactNode} from "react" */
/** @import {StyleProp, TextStyle} from "react-native" */

/**
 * @typedef {object} TextProps
 * @property {ReactNode} [children] Text children.
 * @property {StyleProp<TextStyle>} [style] Text style.
 * @property {string} [testID] Stable test id.
 */

/**
 * Applies project default Text styling before rendering React Native Text.
 * @param {TextProps & Record<string, unknown>} props Values forwarded to the native text element.
 * @returns {ReactElement} Rendered text element.
 */
function Text({style, ...rest}) {
  const {stylesList} = useMergedStyle(style, "Text")

  return <RNText style={stylesList} {...rest} />
}

export default memo(Text)
